import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=78da400e&scoped=true"
var script = {}
import style0 from "./aside.vue?vue&type=style&index=0&id=78da400e&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78da400e",
  null
  
)

export default component.exports